<template>
  <div class="klass_detail">
    <p class="detail_title">
      <span class="title">{{classDetailData.grade + classDetailData.name}}</span>
      <span>详情</span>
    </p>
    <div class="klass_info_wrapper">
      <Row>
        <Col :xs="24" :sm="12" :md="6" :lg="6">
          <span class="info_title">学校：</span>
          <span class="info_txt">{{classDetailData.schoolName}}</span>
        </Col>
        <Col :xs="24" :sm="12" :md="6" :lg="6">
          <span class="info_title">入学年份：</span>
          <span class="info_txt">{{classDetailData.yearId}}</span>
        </Col>
        <Col :xs="24" :sm="12" :md="6" :lg="6">
          <span class="info_title">地区：</span>
          <span class="info_txt">{{classDetailData.region}}</span>
        </Col>
        <Col :xs="24" :sm="12" :md="6" :lg="6">
          <span class="info_title">学生数：</span>
          <span class="info_txt jump_color">{{classDetailData.studentCount}}</span>
        </Col>
      </Row>
    </div>
    <p class="table_caption">教师</p>
    <Table stripe border size="large" :columns="teachersTableHeader" :data="classDetailData.teacherViewInfos">
      <template slot-scope="{row}" slot="name">
        <div :class="[row.activated === 1 ? 'jump_color' : '']" @click="toUserDetail(row.userId,row.activated)">{{row.name}}</div>
      </template>
    </Table>
    <p class="table_caption">操作</p>
    <Table stripe border size="large" :columns="taskNoticesHeader" :data="taskNotices">
      <template slot-scope="{row}" slot="taskCount">
        <div class="jump_color" @click="toTaskList(row.id)">{{row.taskCount}}次</div>
      </template>
      <template slot-scope="{row}" slot="noticeCount">
        <div class="jump_color" @click="toNoticeList(row.id)">{{row.noticeCount}}次</div>
      </template>
    </Table>
  </div>
</template>
<script>
  import {_getClassDetail} from '../api/api';

  export default {
    data() {
      return {
        classId: '', // 班级Id
        classDetailData: {},
        taskNotices:[], // 作业，通知
        teachersTableHeader: [
          {
            title: '称呼',
            key: 'name',
            slot: 'name'
          },
          {
            title: '手机号',
            key: 'phone'
          },
          {
            title: '身份',
            key: 'roleId'
          },
          {
            title: '任教科目',
            key: 'subject'
          },
          {
            title: '微信昵称',
            key: 'nickname'
          },


        ],
        taskNoticesHeader:[
          {
            title: '作业',
            key:'taskCount',
            slot: 'taskCount'
          },
          {
            title: '通知',
            key:'noticeCount',
            slot:'noticeCount'
          },
        ]
      }
    },
    methods: {
//      获取班级详情
      getClassDetail() {
        const self = this;
        _getClassDetail(self.classId).then(res => {
          if (res.code === 0) {
            self.classDetailData = res.data;
            self.taskNotices.push({
              taskCount:res.data.taskCount,
              noticeCount:res.data.noticeCount
            })
          }
        })
      },
//      跳转到用户详情
      toUserDetail(userId,status) {
        if(status) {
          this.$router.push(`/user/detail?id=${userId}`);
        }
      },
//      跳转到作业列表
      toTaskList(){
        this.$router.push(`/tasks?classId=${this.classId}`)
      },
      //      跳转到通知列表
      toNoticeList(){
        this.$router.push(`/notices?classId=${this.classId}`)
      }
    },
    mounted() {
      this.getClassDetail();
    },
    created() {
      this.classId = this.$route.query.id;
    }
  };
</script>
<style scoped>
  .info_title {
    line-height:36px;
    font-size: 16px;
    color:#999;
  }
  .info_txt{
    line-height:36px;
    font-size: 18px;
    color:#333;
  }
</style>



// WEBPACK FOOTER //
// src/components/KlassDetail.vue